import React from "react";
import Main from "../Structure/Main";
import Ep from "../Structure/Ep";
import Animeover from "../Structure/Animeover";
import Footer from "../components/Footer";

export default function Jjk() {
  return (
    <>
      <Main
        img="https://a.storyblok.com/f/178900/2000x3000/8863dbd7c8/jujutsu-kaisen-season-2-key-art.png/m/filters:quality(95)format(webp)"
        name="Jujutsu kaisen"
        s="2"
        e="12"
      />

      <Ep ep="S2-E1 Jujutsu kaisen " s="S2-E1" />
      <Ep ep="S2-E2 Jujutsu kaisen " s="S2-E2" />
      <Ep ep="S2-E3 Jujutsu kaisen " s="S2-E3" />
      <Ep ep="S2-E4 Jujutsu kaisen " s="S2-E4" />
      <Ep ep="S2-E5 Jujutsu kaisen " s="S2-E5" />
      <Ep ep="S2-E6 Jujutsu kaisen " s="S2-E6" />
      <Ep ep="S2-E7 Jujutsu kaisen " s="S2-E7" />
      <Ep ep="S2-E8 Jujutsu kaisen " s="S2-E8" />
      <Ep ep="S2-E9 Jujutsu kaisen " s="S2-E9" />
      <Ep ep="S2-E10 Jujutsu kaisen " s="S2-E10" />
      <Ep ep="S2-E11 Jujutsu kaisen " s="S2-E11" />
      <Ep ep="S2-E12 Jujutsu kaisen " s="S2-E12" />
      <Animeover />
      <Footer />
    </>
  );
}
